const entityIcons = {
  attachment: 'attach',
  cataloguedefinition: 'book',
  cohort: 'filter',
  collection: 'object group outline',
  configuration: 'setting',
  datamodel: 'columns',
  dataset: 'table',
  request: 'key',
  role: 'drivers license',
  search: 'search',
  task: 'calendar check outline',
  taskdefinition: 'edit',
  taskquery: 'boxes',
  theme: 'paint brush',
  user: 'user',
  usergroup: 'users',
  vocabulary: 'font',
  workflow: 'fork',
  workspace: 'cube',
  'workspace.requested': 'hourglass start',
};

export const enabledIcon = (enabled) => (enabled ? 'toggle on' : 'toggle off');
export const lockedIcon = (locked) => (locked ? 'lock' : 'lock open');
export const linkedIcon = (linked) => (linked ? 'linkify' : 'unlinkify');
export const approvedIcon = (approved) => (approved ? 'thumbs up' : 'thumbs down');
export const archivedIcon = (archived) => (archived ? 'archive' : 'undo');

export const visibilityIcon = {
  private: 'user',
  internal: 'users',
  public: 'world',
};

export default entityIcons;
